export const START_KIND_BUSINESS = "business"
export const START_KIND_FIRM = "firm"
export const START_KIND_DEVELOPER = "developer"
/** Arrival from a client-pays invitation email, which links to `/start/client/setup?t=<token>`. */
export const START_KIND_CLIENT = "client"

export const VALID_START_KINDS = [
  START_KIND_BUSINESS,
  START_KIND_FIRM,
  START_KIND_DEVELOPER,
  START_KIND_CLIENT,
] as const
export type StartKind = (typeof VALID_START_KINDS)[number]

/**
 * The registration entry point can be reached without a kind (bare `/start`) or with an
 * unrecognized segment. Those resolve to `unknown` rather than redirecting, so signup still
 * works — we just have no kind to attribute it to.
 */
export const START_KIND_UNKNOWN = "unknown"
export type ResolvedStartKind = StartKind | typeof START_KIND_UNKNOWN

export const START_KIND_PATH_PARAM = "startKind"
